import { Button } from '@/shared/ui/button';
import { Home, ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router';

/** 403 page shown when a route's RequireAbility guard denies access (UX feedback only). */
export default function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100 px-4">
      <div className="max-w-lg w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-200 select-none">403</h1>
          <div className="-mt-8">
            <ShieldAlert className="w-16 h-16 mx-auto text-gray-400" />
          </div>
        </div>

        <h2 className="text-3xl font-bold text-gray-900 mb-4">Access denied</h2>
        <p className="text-gray-600 mb-8 text-lg">
          You don't have permission to view this page. If you think this is a mistake, contact an
          administrator.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={() => navigate('/')}
            size="lg"
            style={{ backgroundColor: '#E84A2B' }}
            className="text-white hover:opacity-90"
          >
            <Home className="w-5 h-5 mr-2" />
            Back to Dashboard
          </Button>
          <Button onClick={() => navigate(-1)} size="lg" variant="outline">
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
